import React from "react";
import { withTranslation } from "react-i18next";
import { PropTypes } from "prop-types";
import SwitchOnOff from "components/common/tools/SwitchOnOff";

function CommentsConfiguration({ params, onChange, t }) {
  return (
    <div className="editor-form-section section-separator editor-comments-configuration-container">
      <div className="editor-form-section-title">
        {t("commentsConfiguration")}
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            name="enable_comments_media"
            iconName=""
            checked={params.enable_comments_media ?? false}
            size="sm"
            onChange={(value) => {
              onChange("enable_comments_media", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableContentComments")}</div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            name="enable_comments_smartlist"
            iconName=""
            checked={params.enable_comments_smartlist ?? false}
            size="sm"
            onChange={(value) => {
              onChange("enable_comments_smartlist", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("enableSmartlistComments")}</div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            name="comments_validation_visibility"
            iconName=""
            checked={params.comments_validation_visibility ?? false}
            size="sm"
            onChange={(value) => {
              onChange("comments_validation_visibility", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("showValidatedComments")}</div>
      </div>
      <div className="editor-form-row editor-form-row-inline">
        <div className="editor-form-input">
          <SwitchOnOff
            name="comments_offline_visibility"
            iconName=""
            checked={params.comments_offline_visibility ?? false}
            size="sm"
            onChange={(value) => {
              onChange("comments_offline_visibility", value);
            }}
          />
        </div>
        <div className="editor-form-label">{t("showOfflineComments")}</div>
      </div>
      <div className="editor-form-input-box-h" style={{ maxWidth: "300px" }}>
        <div className="editor-form-input">
          <input
            type="text"
            value={params.comment_abuse_email}
            maxLength="64"
            placeholder={t("login:emailContent")}
            onChange={(email) => {
              onChange("comment_abuse_email", email.target.value);
            }}
          />
          <small className="report-email-small">{t("reportEmail")}</small>
        </div>
      </div>
    </div>
  );
}

CommentsConfiguration.propTypes = {
  params: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-platform")(CommentsConfiguration);
